import React, {Component} from 'react'
import SwitchWallet from './switchWallet.jsx'
import SwitchWalletRight from './switchWalletRight.jsx'
import {Link} from 'react-router-dom'
import CommonFetch from '../../requests/commonFetch'

export default class Wallet extends Component {
    constructor(props) {
        super(props)

        this.state = {
            tabState: {
                openBlockId: 0,
                activeTab: 'ETH',
                ETH: true,
                CPT: false,
                XEM: false,
                PROOF: false,
                K2G: false,
                K2G_C: false,
                XYO: false,
            },
            currentWallet: {
                address: "",
            },
            data: {
                wallets: [
                    {
                        currency: "",
                        blockchain: "",
                        address: "",
                        balance: "",
                        usd: "",
                        can_be_sent: true,
                        message_field: false,
                        receiver_regexp: "",
                        history: [{currency:"",timestamp:"",direction:"",amount:"",address:""}]
                    }
                ]
            }
        }

        this.translation = JSON.parse(localStorage.translation)[localStorage.language];
    }

    componentDidMount() {
        this.getData();
    }

    getData = () => {
        CommonFetch({
            path: 'ui/wallet/get_data',
            method: 'GET',
        }).then(data => {
            let dataWallets = {
                    wallets: data.wallets,
                },
                firstWallet = data.wallets[0]

                if (data.success) {
                    this.setState({
                        data: dataWallets,
                        currentWallet: firstWallet,
                    })
                } else if (data.error === 'not_logged_in') {
                    this.props.exitOverdueSession()
                }
            })
    }

    switchTab = (tabShortTitle, tabKey, blockchain) => {
        if(tabKey === this.state.tabState.openBlockId) return null

        let tabState = Object.assign({}, this.state.tabState)

        for (let item in tabState) {
            if(item === tabShortTitle) {
                tabState[tabShortTitle] = true;
                tabState.activeTab = tabShortTitle
            } else if (item === 'openBlockId') {
                tabState.openBlockId = tabKey
            } else {
                item !== 'activeTab' ? tabState[item] = false : null
            }
        }

        let currentWallet = {}, allWallets = this.state.data.wallets;
        for (let item in allWallets) {
            if (allWallets[item].currency === tabShortTitle && allWallets[item].blockchain === blockchain) {
                currentWallet = allWallets[item];
                break;
            }
        }

        this.SwitchWalletRight.resetForm();

        this.setState({
            tabState,
            currentWallet: currentWallet,
            feeAmount: 0,
            freeCurrency: '',
        })
    }

    render(){
        return (
            <div className="wallet">
                <div className="wallet_header">
                    <h2>{this.translation['Wallet-balance']}</h2>
                    <hr/>
                </div>
                <div className="wallet_left-side">
                    <p><span>{this.translation['Wallet is']}</span>{this.translation['Wallet is  a cryptocurrency']}</p>
                    {/*<p><span>{this.translation['Frequent questions']}</span></p>*/}
                    {/*<a className="question">{this.translation['How to transfer money to your wallet?']}</a>*/}
                    {/*<a className="question">{this.translation['How buy CPT?']}</a>*/}
                    {/*<a className="question">{this.translation['How withdraw money?']}</a>*/}
                    {/*<a className="question">{this.translation['How to use apps?']}</a>*/}
                    {/*<Link className="question" to="/investor/help">{this.translation['See all']}</Link>*/}
                </div>
                <div className="wallet_right-side">
                    <div className="wallet_right-side_left">
                        <SwitchWallet
                            exitOverdueSession = {this.props.exitOverdueSession}
                            switchTab = {this.switchTab}
                            tabState = {this.state.tabState}
                            data = {this.state.data}
                            currentWallet = {this.state.currentWallet}
                        />
                        <div className="wallet_right-side_left_third"></div>
                    </div>
                    <div className="wallet_right-side_right">
                        <div className="wallet_right-side_right_first">
                            <SwitchWalletRight
                                exitOverdueSession = {this.props.exitOverdueSession}
                                activeTab = {this.state.tabState.activeTab}
                                currentWallet = {this.state.currentWallet}
                                data = {this.state.data}
                                ref={resetForm => { this.SwitchWalletRight = resetForm; }}
                            />
                        </div>
                        <div className="wallet_right-side_right_second">

                        </div>
                        <div className="wallet_right-side_right_third"></div>
                    </div>
                </div>
            </div>
        )
    }
}
